import React, { Component } from 'react';

import {
    Select,
    DatePicker,
    Modal,
    Button,
    Input,
    Tooltip,
    Icon,
    TimePicker,
    Spin,
    Popover
} from 'antd';
import { formDataSchema, addonSchema } from '../../../../schema/financial-counselling'
// import { filter, formData, dissableFormData } from '../../../../schema/apppointment';
import Datepicker from '../../../../components/FormComponent/Date';
import Select2 from '../../../../components/FormComponent/select2';
import Inputlayer from '../../../../components/FormComponent/Input';
import TimepickerLayer from '../../../../components/FormComponent/TimePickerLayer';
import Storage from './../../../../services/local-store';
import networkList from '../../../../constants/networkList';
import postService from '../../../../services/httpService';
import Ins_upload from '../Insurance-Counselling/upload';
import moment from 'moment';
import userTrackService from './../../../../services/usertrack-service';
import Finanical_clearance from '../Insurance-Counselling/finanical-clearance';
import PreView_Model from '../PreView/index';


const $ = require('jquery');

class Finanical_Counselling extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            formData: [],
            addonSchema: [],
            token_data: {},
            payment_mode: null,
            total_cost: 0,
            corporate_comments: null,
            MandatoryDoc: false,
            priview: [],
            priviewmodel: false
        }
    }
    showModal = () => {
        this.setState({
            visible: true
        })
    }
    componentDidMount() {
        const locst = this.props.history.location.state;
        const est_date_of_admis = (locst && locst['est_admis_date']) ? locst['est_admis_date'] : null;
        const params = new URLSearchParams(this.props.location.search);
        const tags = params.get('rid');
        let addon = $.extend({}, addonSchema);
        let form = $.extend({}, formDataSchema);
        console.clear();
        console.log(addon, form);
        let tokenData = JSON.parse(Storage.get('current_token'));
        addon['feilds'].map((data, key) => {
            addon['feilds'][key]['value'] = null;
            addon['feilds'][key]['text'] = null;
            addon['feilds'][key]['disable'] = false;

        });
        form['feilds'].map((data, key) => {
            form['feilds'][key]['value'] = null;
            form['feilds'][key]['disable'] = false;
            form['feilds'][key]['text'] = null;
            form['feilds'][key]['errors'] = [];
            if (tags !== undefined && tags !== null && tags !== '') {
                if (data['name'] === 'counselling_type') {
                    form['feilds'][key]['value'] = 2;
                    form['feilds'][key]['text'] = 'Recounselling';
                    form['feilds'][key]['disable'] = true;
                }
            } else {
                if (data['name'] === 'counselling_type') {
                    form['feilds'][key]['value'] = 1;
                    form['feilds'][key]['text'] = 'Initial';
                    form['feilds'][key]['disable'] = true;
                }
                if (data['name'] === 'estimated_date_of_admission') {
                    form['feilds'][key]['value'] = est_date_of_admis ? moment(est_date_of_admis).format('YYYY-MM-DD') : null;
                    form['feilds'][key]['disable'] = est_date_of_admis ? true : false;
                }
            }
            if (data['name'] === 'package_name' || data['name'] === 'type_of_package' || data['name'] === 'type_of_management' || data['name'] === 'length_of_stay' || data['name'] === 'surgery_procedure_name' || data['name'] === 'date_of_surgery' || data['name'] === 'room_opted' || data['name'] === 'room_upgrade' || data['name'] === 'room_upgrade_reason') {
                form['feilds'][key]['disable'] = true;
                form['feilds'][key]['visible'] = false;

            }
        })
        this.setState((state) => ({ 'addonSchema': addon['feilds'], 'formData': form['feilds'], 'token_data': tokenData }), () => {
            console.clear();
            console.log(this.props);
            const params = new URLSearchParams(this.props.location.search);
            const tags = params.get('rid');
            if (tags !== undefined && tags !== null && tags !== '') {
                this.renderBodydata(tags);
            } else {
                this.renderBody();
            }
            // this.renderBody();
        })
    }

    componentWillUnmount() {
        this.setState((state) => ({
            loadding: false,
            visible: false,
            formData: [],
            addonSchema: [],
            token_data: {},
            payment_mode: null,
            total_cost: 0,
            payment: null,
            corporate_comments: null
        }));
    }

    cancelButton() {
        this.props
            .history
            .push(`/counselling/counsellor-view`);
    }
    handleCancel = e => {
        console.log(e)
        this.setState({ visible: false })
    }

    showInsuranceForm = () => {
        let { formData, token_data, addonSchema, total_cost } = this.state;
        let useData = JSON.parse(Storage.get('user_data'));
        let { createFinancialCouncelling } = networkList;
        let payload = {
            "doctor_Id": token_data['doctor_id'],
            "doctor_speciality": null,
            "umr": token_data['umr'],
            "ip_number": token_data['ip'],
            "patient_name": token_data['patient_name'],
            "patient_mobile": token_data['phone_number'],
            "patient_age": token_data['age'],
            "patient_gender": token_data['gender'],
            "service_id": token_data['privilege_id'],
            "token_number": token_data['id'],
            "token_id": token_data['id'],
            "diagnosis": null,
            "counselling_date": moment(new Date()).format('YYYY-MM-DD  HH:mm'),
            "counselling_type": token_data['privilege_id'],
            "counsellor_id": useData['id'] ? useData['id'] : null,
            "estimated_date_of_admission": null,
            "payment_type": null,
            "care_management": null,
            "estimate_type": null,
            "package_name": null,
            "date_of_surgery": null,
            "length_of_stay": null,
            "surgery_procedure_name": null,
            "room_opted": null,
            "room_opted_name": null,
            "room_upgrade": null,
            "room_upgrade_name": null,
            "room_upgrade_reason": null,
            "corporate_comments": null,

            "room_charges": null,
            "pharmacy_charges": null,
            "Professional_charges": null,
            "cross_consultation_charges": null,
            "investigations_charges": null,
            "procedures_charges": null,
            "ot_charges": null,
            "general_equipment_charges": null,
            "ot_equipment_charges": null,
            "f_b_charges": null,
            "Physiotherapy_charges": null,
            "mlc_charges": null,
            "blood_blank_charges": null,
            "hospital_charges": null,
            "ambulance_charges": null,


            "insurance_company": null,
            "tpa_name": null,
            "insurance_status": null,
            "total_estimate_amount": total_cost,
            "fc_signature": null,
            "patient_signature": null,
            "attendant_signature": null,
            "patient_relation": null,
            "attendant_phone_number": null,
            "type_of_patient": null,
            "pre_auth_status": null,
            "insurance_denied_reason": null,
            "type_of_insurance": null,
            "corporate_name": null,
            "surgery_procedure_id": null,
            "estimate_amount": null,
            "sum_insured_four_years_back": null,
            "consider_si_four_years_back": null,
            "basic_sum_insured": null,
            "buffer_top_up": null,
            "balance_sum_insured": null,
            "room_eligible_percent": null,
            "room_eligible_amount": null,
            "icu_percent": null,
            "icu_amount": null,
            "copay_percent": null,
            "copay_amount": null,
            "package_differance": null,
            "room_eligible_ward": null,
            "room_eligible_ward_name": null,
            "room_eligible_ward_amount": null,
            "upgrade_room": null,
            "upgrade_room_name": null,
            "upgrade_room_amount": null,
            "room_differance": null,
            "pro_rata_differance": null,
            "nme_percent": null,
            "nme_amount": null,
            "ailment_capping_status": "yes",
            "ailment_capping_amount": null,
            "initial_approval_amount": null,
            "submitted_amount": null,
            "final_approval": null,
            "discount": null,
            "extra_deduction": null,
            "remarks": null,
            "differance_amount": null,
            "additional_procedure": [],
            "pre_existing_condition": [],
            "interm_approval": []
        }

        formData
            .map((data, key) => {
                if (data['name'] === 'doctorid') {
                    payload['doctor_Id'] = data['value'];
                }

                if (data['name'] === 'payment') {
                    payload['payment_type'] = data['value'];
                }
                if (data['name'] === 'type_of_management') {
                    payload['care_management'] = data['value'];
                }
                if (data['name'] === 'type_of_package') {
                    payload['estimate_type'] = data['value'];
                }
                if (data['name'] === 'type_of_package') {
                    payload['estimate_type'] = data['value'];
                }
                payload[data['name']] = data['value'];
            })
        addonSchema.map((data, key) => {
            payload[data['name']] = data['value'];
        })
        console.log(payload);


        let errors = [];
        formData
            .map((data, key) => {


                if (data.disable === false && data.visible && data['value'] === null && data['name'] !== 'room_upgrade' && data['name'] !== 'room_upgrade_reason') {
                    errors.push(true);
                    formData[key]['errors'] = [{ 'message': `Please fill ${data['title']}` }];
                } else if (data.disable === false && data.visible && data['name'] === 'room_upgrade_reason') {
                    if (payload['room_upgrade'] !== null && (data['value'] === null || data['value'] === '')) {
                        errors.push(true);
                        formData[key]['title'] = 'Room Upgrade Reason *';
                        formData[key]['errors'] = [{ 'message': `Please fill ${data['title']}` }];
                    } else {
                        errors.push(false);
                    }
                } else {
                    errors.push(false);
                }

            })
        // addonSchema.map((data, key) => {
        //     payload[data['name']] = data['value'];
        // });


        if (!errors.includes(true)) {
            Storage.store('finance_data', payload);
            if (token_data['previous_counselling_id'] === null) {
                this
                    .props
                    .history
                    .push(`/counselling/insurance-counselling`);
            } else {
                this
                    .props
                    .history
                    .push(`/counselling/insurance-counselling?rid=${token_data['previous_counselling_id']}`);
            }
        } else {
            this.setState((state) => ({ loadding: false }));
        }

        // this
        //     .props
        //     .history
        //     .push(`/counselling/insurance-counselling`);
    }
    submitFinanceForm() {
        try {
            window.scrollTo({
                top: 50,
                left: 0,
                behavior: 'smooth'
            });
            let { formData, token_data, addonSchema, total_cost, corporate_comments } = this.state;
            let useData = JSON.parse(Storage.get('user_data'));
            this.setState((state) => ({ loadding: true,priviewmodel: false }));
            let { createFinancialCouncelling, nextPatientforQueue } = networkList;
            let payload = {
                "previous_counselling_id": token_data['previous_counselling_id'] ? parseInt(token_data['previous_counselling_id']) : 0,
                "doctor_Id": token_data['doctor_id'],
                "doctor_speciality": null,
                "umr": token_data['umr'],
                "ip_number": token_data['ip'],
                "patient_name": token_data['patient_name'],
                "patient_mobile": token_data['phone_number'],
                "patient_age": token_data['age'],
                "patient_gender": token_data['gender'],
                "service_id": token_data['privilege_id'],
                "token_number": token_data['id'],
                // "token_id": token_data['token_unique_id'],
                "diagnosis": null,
                "counselling_date": moment(new Date()).format('YYYY-MM-DD hh:mm A'),
                "counselling_type": token_data['privilege_id'],
                "counsellor_id": useData['id'] ? useData['id'] : null,
                "estimated_date_of_admission": null,
                "payment_type": null,
                "care_management": null,
                "estimate_type": null,
                "package_name": null,
                "date_of_surgery": null,
                "length_of_stay": null,
                "surgery_procedure_name": null,
                "room_opted": null,
                "room_opted_name": null,
                "room_upgrade": null,
                "room_upgrade_name": null,
                "room_upgrade_reason": null,
                "corporate_comments": corporate_comments ? corporate_comments : null,

                "room_charges": null,
                "pharmacy_charges": null,
                "Professional_charges": null,
                "cross_consultation_charges": null,
                "investigations_charges": null,
                "procedures_charges": null,
                "ot_charges": null,
                "general_equipment_charges": null,
                "ot_equipment_charges": null,
                "f_b_charges": null,
                "Physiotherapy_charges": null,
                "mlc_charges": null,
                "blood_blank_charges": null,
                "hospital_charges": null,
                "ambulance_charges": null,


                "insurance_company": null,
                "tpa_name": null,
                "insurance_status": null,
                "total_estimate_amount": total_cost,
                "fc_signature": null,
                "patient_signature": null,
                "attendant_signature": null,
                "patient_relation": null,
                "attendant_phone_number": null,
                "type_of_patient": null,
                "pre_auth_status": null,
                "insurance_denied_reason": null,
                "type_of_insurance": null,
                "corporate_name": null,
                "surgery_procedure_id": null,
                "estimate_amount": null,
                "sum_insured_four_years_back": null,
                "consider_si_four_years_back": null,
                "basic_sum_insured": null,
                "buffer_top_up": null,
                "balance_sum_insured": null,
                "room_eligible_percent": null,
                "room_eligible_amount": null,
                "icu_percent": null,
                "icu_amount": null,
                "copay_percent": null,
                "copay_amount": null,
                "package_differance": null,
                "room_eligible_ward": null,
                "room_eligible_ward_name": null,
                "room_eligible_ward_amount": null,
                "upgrade_room": null,
                "upgrade_room_name": null,
                "upgrade_room_amount": null,
                "room_differance": null,
                "pro_rata_differance": null,
                "nme_percent": null,
                "nme_amount": null,
                "ailment_capping_status": "yes",
                "ailment_capping_amount": null,
                "initial_approval_amount": null,
                "submitted_amount": null,
                "final_approval": null,
                "discount": null,
                "extra_deduction": null,
                "remarks": null,
                "differance_amount": null,
                "additional_procedure": [],
                "pre_existing_condition": [],
                "interm_approval": []
            }

            // if (token_data['age'] !== null && token_data['age'] !== undefined) {
            //     let age = token_data['age'].split("Y");
            //     payload['patient_age'] = parseInt(age[0]);
            // }
            if (payload['payment_type'] !== 3) {
                addonSchema.map((data, key) => {
                    payload[data['name']] = data['value'];
                });
            }
            let errors = [];
            formData
                .map((data, key) => {

                    if (data.visible) {

                        if (data['name'] === 'doctorid') {
                            payload['doctor_Id'] = data['value'];
                        }

                        if (data['name'] === 'payment') {
                            payload['payment_type'] = data['value'];
                        }
                        if (data['name'] === 'type_of_management') {
                            payload['care_management'] = data['value'];
                        }
                        if (data['name'] === 'type_of_package') {
                            payload['estimate_type'] = data['value'];
                        }
                      


                        payload[data['name']] = data['value'];


                        if (data['name'] === 'room_opted') {
                            payload['room_opted'] = data['package_id'];
                            payload['room_opted_name'] = data['text'];
                            if(payload['estimate_type']===1){
                                payload['room_charges']=data['amount']
                            }
                        }
                        if (data['name'] === 'room_upgrade') {
                            payload['room_upgrade'] = data['package_id'];
                            payload['room_upgrade_name'] = data['text'];
                        }

                        if (data['name'] === 'counselling_date') {
                            payload['counselling_date'] = moment(new Date()).format('YYYY-MM-DD hh:mm A');
                        }
                    } else {
                        payload[data['name']] = null;
                        // payload['room_upgrade'] = null;
                        // payload['room_upgrade_name'] = null;
                        // payload['room_opted'] = null;
                        // payload['room_opted_name'] = null;
                        // payload['estimate_type'] = null;
                        // payload['care_management'] = null;
                    }

                    // if (data.disable === false && data.visible && data['value'] === null && data['name'] !== 'room_upgrade' && data['name'] !== 'room_upgrade_reason') {
                    //     errors.push(true);
                    //     formData[key]['errors'] = [{ 'message': `Please fill ${data['title']}` }];
                    // } else if (data.disable === false && data.visible && data['name'] === 'room_upgrade_reason') {
                    //     if (payload['room_upgrade'] !== null && (data['value'] === null || data['value'] === '')) {
                    //         errors.push(true);
                    //         formData[key]['title'] = 'Room Upgrade Reason *';
                    //         formData[key]['errors'] = [{ 'message': `Please fill ${data['title']}` }];
                    //     } else {
                    //         errors.push(false);
                    //     }
                    // } else {
                    //     errors.push(false);
                    // }

                })
            
            if (payload['payment_type'] === 3) {
                payload['total_estimate_amount'] = 0;
            }



            let This = this;

            // this.setState((state) => ({ loadding: false }));
            // console.clear();
            // console.log(payload);
            // return true;

            if (!errors.includes(true)) {
                const Userlogobj = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "Create Financial Councelling - Request",
                        "date": new Date(),
                        "meta": payload
                    }
                }
                userTrackService(Userlogobj);
                postService(createFinancialCouncelling, 'POST', { 'data': payload }).then(res => {
                    const Userlogobjres ={
                        "data": {
                            "user": JSON.parse(localStorage.getItem('user')),
                            "action": "Create Financial Councelling - Response",
                            "date": new Date(),
                            "meta": res
                        }
                    }
                    userTrackService(Userlogobjres);
                    console.log(res);
                    this.setState((state) => ({ loadding: false }));
                    if (res.status) {
                        Storage.store('print_response', res['data']);
                        localStorage.removeItem('room_eligible_ward_cost');
                        localStorage.removeItem('payment');
                        localStorage.removeItem('type_of_package');
                        localStorage.removeItem('package_name');
                        localStorage.removeItem('current_token');
                        Modal.success({
                            title: 'Success Message',
                            content: 'Counselling Sucessfully Completed',
                            onOk: function () {
                                This
                                    .props
                                    .history
                                    .push(`/counselling/counselling-print?token_data=${token_data ? token_data['id'] : null}`);

                                // This.renderNextToken(token_data);
                                // This
                                // .props
                                // .history
                                // .push(`/counselling/counsellor-view`);
                            }
                        })



                    } else {
                        Modal.error({
                            title: 'Error Message',
                            content: 'Some Thing went wrong,Please try again. later',

                        })
                    }
                }).catch((error) => {
                    this.setState((state) => ({ loadding: false }));
                    console.log(error);
                    Modal.error({
                        title: 'Error Message',
                        content: 'Some Thing went wrong,Please try again. later',

                    })
                });
            } else {
                this.setState((state) => ({ loadding: false }));
            }
        } catch (error) {
            this.setState((state) => ({ loadding: false }));
            console.log(error);
            Modal.error({
                title: 'Error Message',
                content: 'Some Thing went wrong,Please try again. later',

            })
        }
    }
    previewdata() {
        try {
            window.scrollTo({
                top: 50,
                left: 0,
                behavior: 'smooth'
            });
            let { formData, token_data, addonSchema, total_cost, corporate_comments } = this.state;
            let useData = JSON.parse(Storage.get('user_data'));
            // this.setState((state) => ({ loadding: true }));
            let { createFinancialCouncelling, nextPatientforQueue } = networkList;
            let preview = {
                "previous_counselling_id": token_data['previous_counselling_id'] ? parseInt(token_data['previous_counselling_id']) : 0,
                "doctor_Id": token_data['doctor_id'],
                "doctor_name":token_data['doctor_name'],
                "doctor_speciality": null,
                "umr": token_data['umr'],
                "ip_number": token_data['ip'],
                "patient_name": token_data['patient_name'],
                "patient_mobile": token_data['phone_number'],
                "patient_age": token_data['age'],
                "patient_gender": token_data['gender'],
                "service_id": token_data['privilege_id'],
                "token_number": token_data['id'],
                // "token_id": token_data['token_unique_id'],
                "diagnosis": null,
                "counselling_date": moment(new Date()).format('YYYY-MM-DD hh:mm A'),
                "counselling_name": token_data['privilege_name'],
                "counsellor_id": useData['id'] ? useData['id'] : null,
                "estimated_date_of_admission": null,
                "payment_type": 'Cash',
                "care_management": null,
                "estimate_type": null,
                "package_name": null,
                "date_of_surgery": null,
                "length_of_stay": null,
                "surgery_procedure_name": null,
                "room_opted": null,
                "room_opted_name": null,
                "room_upgrade": null,
                "room_upgrade_name": null,
                "room_upgrade_reason": null,
                "corporate_comments": corporate_comments ? corporate_comments : null,

                "room_charges": null,
                "pharmacy_charges": null,
                "Professional_charges": null,
                "cross_consultation_charges": null,
                "investigations_charges": null,
                "procedures_charges": null,
                "ot_charges": null,
                "general_equipment_charges": null,
                "ot_equipment_charges": null,
                "f_b_charges": null,
                "Physiotherapy_charges": null,
                "mlc_charges": null,
                "blood_blank_charges": null,
                "hospital_charges": null,
                "ambulance_charges": null,


                "insurance_company": null,
                "tpa_name": null,
                "insurance_status": null,
                "total_estimate_amount": total_cost,
                "fc_signature": null,
                "patient_signature": null,
                "attendant_signature": null,
                "patient_relation": null,
                "attendant_phone_number": null,
                "type_of_patient": null,
                "pre_auth_status": null,
                "insurance_denied_reason": null,
                "type_of_insurance": null,
                "corporate_name": null,
                "surgery_procedure_id": null,
                "estimate_amount": null,
                "sum_insured_four_years_back": null,
                "consider_si_four_years_back": null,
                "basic_sum_insured": null,
                "buffer_top_up": null,
                "balance_sum_insured": null,
                "room_eligible_percent": null,
                "room_eligible_amount": null,
                "icu_percent": null,
                "icu_amount": null,
                "copay_percent": null,
                "copay_amount": null,
                "package_differance": null,
                "room_eligible_ward": null,
                "room_eligible_ward_name": null,
                "room_eligible_ward_amount": null,
                "upgrade_room": null,
                'room_upgrade_reason_name':null,
                "upgrade_room_name": null,
                "upgrade_room_amount": null,
                "room_differance": null,
                "pro_rata_differance": null,
                "nme_percent": null,
                "nme_amount": null,
                "ailment_capping_status": "yes",
                "ailment_capping_amount": null,
                "initial_approval_amount": null,
                "submitted_amount": null,
                "final_approval": null,
                "discount": null,
                "extra_deduction": null,
                "remarks": null,
                "differance_amount": null,
                "additional_procedure": [],
                "pre_existing_condition": [],
                "interm_approval": []
            }


            let errors = [];
            formData
                .map((data, key) => {

                    if (data.visible) {

                        if (data['name'] === 'doctorid') {
                             preview['doctor_Id'] = data['text'];
                        }
                        
                        if (data['name'] === 'type_of_management') {
                            preview['care_management'] = data['text'];
                        }
                        if (data['name'] === 'type_of_package') {
                            preview['estimate_type'] = data['text'];
                            
                        }
                        if (data['name'] === 'type_of_package') {
                            preview['estimate_type'] = data['text'];
                        }


                        preview[data['name']] = data['value'];


                        if (data['name'] === 'room_opted') {
                            preview['room_opted'] = data['package_id'];
                            preview['room_opted_name'] = data['text'];
                        }
                        if (data['name'] === 'room_upgrade') {
                            preview['room_upgrade_name'] = data['text'];
                        }
                        if (data['name'] === 'room_upgrade_reason') {
                            preview['room_upgrade_reason_value'] = data['value'];
                            preview['room_upgrade_reason_name'] = data['text'];
                        }
                        if (data['name'] === 'length_of_stay') {
                            preview['length_of_stay'] = data['value'];
                          
                        }
                        if (data['name'] === 'surgery_procedure_name') {
                            preview['surgery_procedure_name'] = data['text'];
                        }

                        if (data['name'] === 'counselling_date') {
                            preview['counselling_date'] = moment(new Date()).format('YYYY-MM-DD hh:mm A');
                        }
                    } else {
                        preview[data['name']] = null;
                        preview['room_upgrade'] = null;
                        preview['room_upgrade_name'] = null;
                        preview['room_opted'] = null;
                        preview['room_opted_name'] = null;
                        preview['estimate_type'] = null;
                        preview['care_management'] = null;
                    }

                    if (data.disable === false && data.visible && data['value'] === null && data['name'] !== 'room_upgrade' && data['name'] !== 'room_upgrade_reason') {
                        errors.push(true);
                        formData[key]['errors'] = [{ 'message': `Please fill ${data['title']}` }];
                    } else if (data.disable === false && data.visible && data['name'] === 'room_upgrade_reason') {
                        if (preview['room_upgrade'] !== null && (data['value'] === null || data['value'] === '')) {
                            errors.push(true);
                            formData[key]['title'] = 'Room Upgrade Reason *';
                            formData[key]['errors'] = [{ 'message': `Please fill ${data['title']}` }];
                        } else {
                            errors.push(false);
                        }
                    } else {
                        errors.push(false);
                    }

                })
            if (preview['payment_type'] !== 3) {
                addonSchema.map((data, key) => {
                    preview[data['name']] = data['value'];
                });
            }
            if (preview['payment_type'] === 3) {
                preview['total_estimate_amount'] = 0;
            }



            let This = this;

            // this.setState((state) => ({ loadding: false }));
            // console.clear();
            // console.log(preview);
            // return true;

            if (!errors.includes(true)) {
              
                this.setState({ priview: preview, priviewmodel: true });
            } else {
                this.setState((state) => ({ loadding: false }));
                Modal.error({
                    title: 'Error Message',
                    content: 'Please Enter All Mandatory Feilds',
                    onOk: () => {
                        window.scrollTo({
                            top: 50,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                })
            }
        } catch (error) {
            this.setState((state) => ({ loadding: false }));
            console.log(error);
            Modal.error({
                title: 'Error Message',
                content: 'Some Thing went wrong,Please try again. later',

            })
        }
    }

    checkBreak = (token_data) => {
        const Userlogobj = {
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "get User Break Status - Request",
                "date": new Date(),
                "meta": null
            }
        }
        userTrackService(Userlogobj);
        postService('getUserBreakStatus', 'GET', 'null').then(res => {
            const Userlogobjres = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "get User Break Status - Response",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            if (res.status) {
                if (res['data'] && res['data']['break_status'] && res['data']['break_status'] === 1) {

                    let This = this;
                    Modal.success({
                        title: 'Success Message',
                        content: 'Counselling Sucessfully Completed',
                        onOk: function () {
                            This.props
                                .history
                                .push(`/counselling/counselling-print`);

                        }
                    })
                } else {
                    // this.renderNextToken(token_data);
                    this
                        .props
                        .history
                        .push(`/counselling/counselling-print?token_data=${token_data ? token_data['id'] : null}`);
                }
                // this.setState({ 'break_status': res['data']['break_status'] })
                // console.log(res);
            } else {
                this.setState({ 'break_status': 0 })
            }
        });
    }


    renderNextToken(token_data) {
        let { createFinancialCouncelling, nextPatientforQueue } = networkList;
        let obj = { 'id': token_data ? token_data['id'] : null }
        console.log(obj);
        const Userlogobj = {
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "Next Patient for Queue - Request",
                "date": new Date(),
                "meta": obj
            }
        }
        userTrackService(Userlogobj);
        postService(nextPatientforQueue, 'POST', { 'data': obj }).then(res => {
            const Userlogobjres = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "Next Patient for Queue - Response",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            if (res['status']) {
                localStorage.removeItem('finance_data');
                localStorage.removeItem('current_token');
                // this.nextRenderBody();
                this
                    .props
                    .history
                    .push(`/counselling/counselling-print`);
            } else {
                this.setState((state) => ({ loadding: false }));
                Modal.error({
                    title: 'Error Message',
                    content: 'Token is not Updated, Please try again.',
                })
            }
        })
    }

    nextRenderBody() {
        let { nextAssignTokenToCounsellor } = networkList;
        const Userlogobj = {
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "next Assign Token To Counsellor- Request",
                "date": new Date(),
                "meta": null
            }
        }
        userTrackService(Userlogobj);
        postService(nextAssignTokenToCounsellor, 'GET', 'null').then(res => {
            const Userlogobjres = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "next Assign Token To Counsellor- Response",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            if (res.status) {
                Storage.store('current_token', res['data']);
            } else {

            }
        });
    }


    handleChange(attr) {
        
        console.clear();
        console.log(attr);
        let payment = null;
        let type_package = null;
        let type_of_management = null;
        let { formData, addonSchema } = this.state;
        let total_cost = 0;
        let length_of_stay = null;
        addonSchema.map((adata, akey) => {

            if (adata['name'] === attr['name']) {
                adata['value'] = attr.value;
                adata['text'] = attr.text;
                adata['valid'] = true;
                addonSchema[akey] = adata;
            }
        })
        formData
            .map((data, key) => {
                if (data['name'] === attr['name']) {

                    data['value'] = attr.value;
                    data['amount'] = attr.amount ? attr.amount : null;
                    data['package_id'] = attr.package_id ? attr.package_id : null;
                    data['text'] = attr.text;
                    data['valid'] = true;
                    formData[key] = data;
                    if (attr['name'] === 'room_opted') {
                        localStorage.setItem('room_eligible_ward_cost', attr.amount);
                    }
                    if (attr['name'] === 'type_of_package') {
                        localStorage.setItem('type_of_package', attr.value);
                    }
                    if (attr['name'] === 'package_name') {
                        localStorage.setItem('package_name', attr.value)
                        length_of_stay = attr.length_of_stay;
                    }



                }

                if (data['name'] === 'length_of_stay') {
                    data['value'] = length_of_stay ? length_of_stay : data.value;
                    data['text'] = length_of_stay ? length_of_stay : data.text;
                    data['valid'] = true;
                    data['disable'] = false;
                    if (length_of_stay !== undefined && length_of_stay !== null) {
                        data['disable'] = true;
                    }
                }

                if (data['name'] === 'payment') {
                    payment = data.value;
                    if (data.value === 1) {
                        localStorage.setItem('payment', 'Cash')
                        this.setState((state) => ({ 'payment_mode': true, 'payment': data.value }));
                    } else if (data.value === 3) {
                        localStorage.setItem('payment', 'Corporate');
                        this.setState((state) => ({ 'payment_mode': true, 'payment': data.value }));
                    } else {
                        localStorage.setItem('payment', 'Insurance');
                        this.setState((state) => ({ 'payment_mode': false, 'payment': data.value }));
                    }
                }

                if (data['name'] === 'type_of_package') {
                    type_package = data.value;
                    if (payment === 1) {
                        data['disable'] = false;
                        data['visible'] = true;
                        if (type_of_management === 2) {
                            data['disable'] = false;
                            data['visible'] = true;
                        } else {
                            data['disable'] = true;
                            data['visible'] = false;
                        }
                    } else {
                        data['disable'] = true;
                        data['visible'] = false;
                    }

                }


                if (data['name'] === 'length_of_stay' || data['name'] === 'surgery_procedure_name' || data['name'] === 'date_of_surgery' || data['name'] === 'room_opted') {
                    if (payment === 1) {
                        data['disable'] = false;
                        data['visible'] = true;
                    } else {
                        data['disable'] = true;
                        data['visible'] = false;
                    }
                }

                if (data['name'] === 'room_upgrade' || data['name'] === 'room_upgrade_reason') {
                    if (payment === 1) {
                        data['disable'] = true;
                        data['visible'] = true;
                    }
                    if (payment !== 1) {
                        data['disable'] = true;
                        data['visible'] = false;
                    }
                    if (data['name'] === 'room_upgrade_reason') {
                        data['title'] = 'Room Upgrade Reason';
                    }
                }


                if (data['name'] === 'surgery_procedure_name') {
                    let type_of_package = localStorage.getItem('type_of_package');
                    if (type_of_package == 1) {
                        data['disable'] = false;
                        data['visible'] = true;
                    } else {
                        data['disable'] = false;
                        data['visible'] = true;
                    }
                }

                if (data['name'] === 'package_name') {
                    if (payment === 1) {
                        data['disable'] = false;
                        data['visible'] = true;
                        if (type_package === 1) {
                            data['disable'] = false;
                            data['visible'] = true;
                        } else {
                            data['disable'] = true;
                            data['visible'] = false;
                        }
                    } else {
                        data['disable'] = true;
                        data['visible'] = false;
                    }

                }

                if (data['name'] === 'type_of_management') {
                    type_of_management = data.value;
                    if (payment === 1) {
                        data['disable'] = false;
                        data['visible'] = true;
                    } else {
                        data['disable'] = true;
                        data['visible'] = false;
                    }
                }




                if (attr['name'] === 'doctorid') {
                    formData
                        .map((fdata, fkey) => {
                            if (fdata['name'] === 'doctor_speciality') {
                                formData[fkey]['disable'] = true;
                                formData[fkey]['value'] = attr.speciality_id;
                                formData[fkey]['text'] = attr.speciality;
                                formData[fkey]['visible'] = true;
                            }
                        })
                }




                // if (attr['name'] === 'room_opted') {
                //     total_cost = total_cost + parseFloat(attr.amount);
                // }
            });






        if (attr['name'] === 'type_of_management') {
            total_cost = 0;
            localStorage.removeItem('package_name');
            localStorage.removeItem('type_of_package');
            localStorage.removeItem('room_eligible_ward_cost');
            formData
                .map((data, key) => {
                    formData[key]['errors'] = [];
                    if (data['name'] === 'package_name' || data['name'] === 'type_of_package' || data['name'] === 'length_of_stay' || data['name'] === 'room_opted' || data['name'] === 'room_upgrade' || data['name'] === 'room_upgrade_reason') {
                        formData[key]['value'] = null;
                        formData[key]['text'] = null;
                        formData[key]['errors'] = [];
                    }

                    addonSchema.map((adata, akey) => {

                        // if (adata['name'] === attr['name']) {
                        adata['value'] = null;
                        adata['text'] = null;
                        adata['valid'] = true;
                        addonSchema[akey] = adata;
                        // }
                    })

                    if (attr['value'] === 1) {
                        if (data['name'] === 'package_name' || data['name'] === 'type_of_package' || data['name'] === 'surgery_procedure_name' || data['name'] === 'date_of_surgery') {
                            formData[key]['visible'] = false;
                        }
                    } else {
                        if (data['name'] === 'package_name' || data['name'] === 'type_of_package' || data['name'] === 'surgery_procedure_name' || data['name'] === 'date_of_surgery') {
                            formData[key]['visible'] = true;
                        }
                    }

                })
        }



        if (attr['name'] === 'type_of_package') {
            total_cost = 0;
            localStorage.removeItem('package_name');
            formData
                .map((data, key) => {
                    if (data['name'] === 'package_name' || data['name'] === 'length_of_stay' || data['name'] === 'date_of_surgery' || data['name'] === 'room_opted' || data['name'] === 'room_upgrade' || data['name'] === 'room_upgrade_reason') {
                        formData[key]['value'] = null;
                        formData[key]['text'] = null;
                        formData[key]['errors'] = [];
                    }

                    if (attr['value'] === 1) {
                        if (data['name'] === 'surgery_procedure_name') {
                            formData[key]['visible'] = false;
                        }
                        if (data['name'] === 'length_of_stay') {
                            formData[key]['disable'] = true;
                        }
                    } else {
                        if (data['name'] === 'surgery_procedure_name') {
                            formData[key]['visible'] = true;
                        }
                        if (data['name'] === 'length_of_stay') {
                            formData[key]['disable'] = false;
                        }
                    }

                })
        }


        if (attr['name'] === 'package_name') {
            total_cost = 0;

            formData
                .map((data, key) => {

                    if (data['name'] === 'length_of_stay') {
                        formData[key]['disable'] = true;
                    }
                    if (data['name'] === 'surgery_procedure_name') {
                        formData[key]['visible'] = false;
                    }

                })
        }

        if (attr['name'] === 'room_opted') {
            let package_type = null;
            formData
                .map((data, key) => {
                    if ((data['name'] === 'type_of_management' && data['value'] !== null && data['value'] === 1) || (data['name'] === 'type_of_package' && data['value'] !== null && data['value'] === 2)) {

                        package_type = data['value'];

                    }

                    if (data['name'] === 'room_upgrade' && attr['value'] && attr['value'] !== '') {
                        formData[key]['value'] = null;
                        formData[key]['text'] = null;
                        formData[key]['disable'] = false;
                        formData[key]['errors'] = [];
                    }
                    if (data['name'] === 'room_upgrade_reason' && attr['value'] && attr['value'] !== '') {
                        formData[key]['value'] = null;
                        formData[key]['text'] = null;
                        formData[key]['disable'] = true;
                        formData[key]['errors'] = [];
                    }

                });
            addonSchema.map((adata, akey) => {
                if (adata['name'] === 'room_charges' && package_type !== null && package_type !== '') {
                    addonSchema[akey]['value'] = attr.amount;
                    addonSchema[akey]['disable'] = true;
                }
                if (adata['name'] === 'room_charges' && package_type === null) {
                    addonSchema[akey]['value'] = null;
                    addonSchema[akey]['text'] = null;
                    addonSchema[akey]['disable'] = true;
                }
            });
        }


        if (attr['name'] === 'room_upgrade') {
            let package_type = null;
            formData
                .map((data, key) => {
                    // if ((data['name'] === 'type_of_management' && data['value'] !== null && data['value'] === 1) || (data['name'] === 'type_of_package' && data['value'] !== null && data['value'] === 2)) {

                    //     package_type = data['value'];

                    // }

                    if (data['name'] === 'room_upgrade_reason' && attr['value'] && attr['value'] !== '') {
                        formData[key]['value'] = null;
                        formData[key]['text'] = null;
                        formData[key]['title'] = 'Room Upgrade Reason *';
                        formData[key]['disable'] = false;
                        formData[key]['errors'] = [];
                    }

                    if (data['name'] === 'room_upgrade_reason' && (attr['value'] === null || attr['value'] === '')) {
                        formData[key]['value'] = null;
                        formData[key]['text'] = null;
                        formData[key]['disable'] = true;
                        formData[key]['title'] = 'Room Upgrade Reason';
                        formData[key]['errors'] = [];
                    }

                });
            // addonSchema.map((adata, akey) => {
            //     if (adata['name'] === 'room_charges' && package_type !== null && package_type !== '') {
            //         addonSchema[akey]['value'] = attr.amount;
            //         addonSchema[akey]['disable'] = true;
            //     }
            //     if (adata['name'] === 'room_charges' && package_type === null) {
            //         addonSchema[akey]['value'] = null;
            //         addonSchema[akey]['text'] = null;
            //         addonSchema[akey]['disable'] = true;
            //     }
            // });
        }

        let room_opted = null;
        let upgrade_room = null;
        formData
            .map((data, key) => {

                if (data['name'] === 'room_opted') {
                    room_opted = data['value'];
                }
                if (data['name'] === 'room_upgrade') {
                    upgrade_room = data['value'];
                    if (room_opted && room_opted !== '') {
                        formData[key]['disable'] = false;
                    }
                    if (room_opted === null) {
                        formData[key]['disable'] = true;
                    }

                }
                if (data['name'] === 'room_upgrade_reason' && upgrade_room && upgrade_room !== '') {
                    formData[key]['disable'] = false;
                }
                if (data['name'] === 'room_upgrade_reason' && upgrade_room === null) {
                    formData[key]['disable'] = true;
                }

            })


        this.setState((state) => ({ 'addonSchema': addonSchema, 'formData': formData, 'total_cost': total_cost }), () => {
            this.caluculateTotal();
        })

        // mandatory Docs logic
        if (attr['name'] === 'payment' && attr['value'] == 1) {
            this.MandatoryDoc(false)
        }
        if (attr['name'] === 'payment' && attr['value'] == 2) {
            // insurance           
            this.MandatoryDoc(true)
        }
        if (attr['name'] === 'payment' && attr['value'] == 3) {
            this.MandatoryDoc(false)
        }
    }

    MandatoryDoc = (MandatoryDoc) => {
        let payload = {}
        let tokenData = {}
        let user_data = {}
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        if (localStorage.getItem('current_token') !== null) {
            tokenData = JSON.parse(Storage.get('current_token'));
        }
        payload = { "umr_no": tokenData['umr'], "ip_no": tokenData['ip'], "unit_id": user_data['unitid'], "form_type": "add", "counselling_id": '' }
        try {
            postService('getPatientDocumentDetails', 'POST', { "data": payload }).then(res => {
                if (res['status']) {
                    this.setState({ loadding: false })
                    // Storage.store('getPatientDocumentDetails', res['data'])
                    let patDocDetails = res['data'] ? res['data'] : []

                    if (MandatoryDoc) {
                        //   if insurance call the checked API
                        let getMasterDocumentTypes = JSON.parse(Storage.get('getMasterDocumentTypes'));
                        let getPatientDocumentDetails = patDocDetails;
                        let outputmasterDoc = []
                        let outputPatientDoc = []
                        let obj = {}
                        getMasterDocumentTypes && getMasterDocumentTypes.filter((data, key) => {
                            if (data['is_mandatory'] === 1) {
                                obj = { id: data['id'], document_type: data['document_type'] }
                                outputmasterDoc.push(obj)
                            }
                        })
                        getPatientDocumentDetails && getPatientDocumentDetails.filter((data, key) => {
                            outputPatientDoc.push(parseInt(data['document_id']))
                        })
                        // console.log('output:', outputmasterDoc, outputPatientDoc)
                        outputmasterDoc.map((data, key) => {
                            if (outputPatientDoc.includes(data.id)) {
                                // console.log('yes:', data)
                            } else {
                                // console.log('no:', data)
                                this.checked_true(data)
                            }
                        })
                    } else {
                        let getMasterDocumentTypes = JSON.parse(Storage.get('getMasterDocumentTypes'));
                        let getPatientDocumentDetails = patDocDetails;
                        let outputmasterDoc = []
                        let outputPatientDoc = []
                        let obj = {}
                        getMasterDocumentTypes && getMasterDocumentTypes.filter((data, key) => {
                            if (data['is_mandatory'] === 1) {
                                obj = { id: data['id'], document_type: data['document_type'] }
                                outputmasterDoc.push(obj)
                            }
                        })
                        let obj2 = {}
                        getPatientDocumentDetails && getPatientDocumentDetails.filter((data, key) => {
                            if (data.document_url == null) {
                                //no files obj
                                obj2 = { id: parseInt(data['document_id']), file_uploading_id: data['file_uploading_id'] }
                                outputPatientDoc.push(obj2)
                            } else {
                                // yes files obj
                            }
                        })
                        // console.log('output:', outputmasterDoc, outputPatientDoc)
                        let checked_false_obj = []
                        outputmasterDoc.map((data, key) => {
                            let patDocData = outputPatientDoc.filter(data2 => data2.id == data.id)

                            if (patDocData.length > 0) {
                                //    no files array
                                checked_false_obj.push(patDocData[0])
                            } else {
                                // console.log('no:', patDocData)
                            }
                        })
                        checked_false_obj.length > 0 && checked_false_obj.map((data, key) => {
                            this.checked_false(data)
                        })
                    }
                } else {
                    this.setState((state) => ({ 'patientDocument': [] }));
                    this.setState({ loadding: false })
                }
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            // Modal.error({
            //     title: 'Error Message',
            //     content: 'Oops, Something is wrong. Please try again.',
            // })

        }
    }

    checked_true = (body) => {
        this.setState({ loadding: true })
        let user_data = null
        let tokenData = null
        let ip_no = null
        let umr_no = null
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        } else {
            // Modal.error({
            //     title: `Failure`,
            //     content: `unit is null.`,
            //     zIndex: '1022'
            // });
        }
        if (localStorage.getItem('current_token') !== null) {
            tokenData = JSON.parse(Storage.get('current_token'));
            umr_no = tokenData['umr']
        }

        if (umr_no && body && body.id && user_data['unitid']) {
            var num = body.id;
            var id = num.toString();

            if (body['document_type'] === 'KYC') {
                ip_no = null;
            } else {
                ip_no = tokenData['ip'];
            }
            let payload = {
                "umr": umr_no,
                "ip": ip_no,
                "document_id": id,
                "unit_id": user_data['unitid'],
                "counselling_id": null
            }
            // console.log('form_data:', payload);

            try {
                postService('enableFileUpload', 'POST', { 'data': payload }).then(res => {
                    // console.log('enableFileUpload response:', res);
                    if (res.status) {
                        this.setState({ loadding: false })
                    } else {
                        // Modal.error({
                        //     title: `Failure`,
                        //     content: `${res.message}`,
                        //     zIndex: '1022'
                        // });
                        this.setState({ loadding: false })
                    }

                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                // Modal.error({
                //     title: 'Error Message',
                //     content: 'Oops, Something is wrong. Please try again.',
                //     zIndex: '1022'
                // })

            }
        } else {
            // Modal.error({
            //     title: `Failure`,
            //     content: `Oops, something went wrong. Please try again.`,
            //     zIndex: '1022'
            // });
            this.setState({ loadding: false })
        }
    }
    checked_false = (item) => {
        this.setState({ loadding: true })
        let file_uploading_id = item ? item['file_uploading_id'] : false
        if (file_uploading_id) {
            let payload = {
                "file_uploading_id": item ? item['file_uploading_id'].toString() : null,
            }
            console.log('form_data:', payload);

            try {
                postService('disableFileUpload', 'POST', { 'data': payload }).then(res => {
                    console.log('fileupload response:', res);
                    if (res.status) {
                        this.setState({ loadding: false })
                    } else {
                        // Modal.error({
                        //     title: `Failure`,
                        //     content: `${res.message}`,
                        //     zIndex: '1022'
                        // });
                        this.setState({ loadding: false })
                    }

                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                // Modal.error({
                //     title: 'Error Message',
                //     content: 'Oops, Something is wrong. Please try again.',
                //     zIndex: '1022'
                // })

            }
        } else {
            // Modal.error({
            //     title: `Failure`,
            //     content: `Oops, something went wrong. Please try again.`,
            //     zIndex: '1022'
            // });
            this.setState({ loadding: false })
        }
    }
    commentsChange(event) {
        console.clear();
        console.log(event.target.value);
        let value = event.target.value;
        this.setState((state) => ({ 'corporate_comments': value }));
        // corporate_comments
    }

    caluculateTotal() {
        let { formData, addonSchema } = this.state;
        let total_cost = 0;
        let package_type = null
        let mode_of_payment = null;
        let length_of_stay = null

        let type_of_management = null;
        let type_of_package = null;
        let room_opted = 0;
        let room_charges = 0
        formData
            .map((data, key) => {
                if (data['name'] === 'payment' && data['value'] !== null && data['value'] !== '') {
                    mode_of_payment = data['value'];
                }

                if ((data['name'] === 'type_of_management' && data['value'] !== null && data['value'] === 1) || (data['name'] === 'type_of_package' && data['value'] !== null && data['value'] === 2)) {
                    package_type = data['value'];
                }

                if (data['name'] === 'type_of_management' && data['value'] !== null && data['value'] !== '') {
                    type_of_management = data['value']
                }

                if (data['name'] === 'type_of_package' && data['value'] !== null && data['value'] !== '') {
                    type_of_package = data['value']
                }


                if (data['name'] === 'surgery_procedure_name' && mode_of_payment !== null) {
                    if (mode_of_payment === 1) {
                        formData[key]['visible'] = true;
                    } else {
                        formData[key]['visible'] = false;
                    }

                    if (package_type === 1) {
                        formData[key]['visible'] = false;
                    } if (package_type === 2) {
                        formData[key]['visible'] = true;
                    }

                    // formData[key]['value'] = null;
                    // formData[key]['text'] = null;

                }

                if (data['name'] === 'date_of_surgery' && mode_of_payment !== null) {

                    if (mode_of_payment === 1) {
                        formData[key]['visible'] = true;
                    } else {
                        formData[key]['visible'] = false;
                    }

                    if (package_type === 1) {
                        formData[key]['visible'] = false;
                    } if (package_type === 2) {
                        formData[key]['visible'] = true;
                    }

                    // formData[key]['value'] = null;
                    // formData[key]['text'] = null;

                }


                if (data['name'] === 'length_of_stay' && data['value'] !== null && data['value'] !== '') {

                    length_of_stay = data['value'];
                    formData[key]['disable'] = false;
                    if (type_of_management === 2 && type_of_package === 1) {
                        formData[key]['disable'] = true;
                    }
                }
                if (data['name'] === 'room_opted' && data['value'] !== null && data['value'] !== '' && data['amount'] !== null && data['amount'] !== '') {
                    // total_cost = total_cost + parseFloat(data['amount']);
                    room_opted = parseFloat(data['amount'] ? data['amount'] : 0);
                    if (type_of_management === 2 && type_of_package === 1) {
                        total_cost = total_cost + parseFloat(data['amount'] ? data['amount'] : 0);
                    }
                }
            });

        addonSchema.map((adata, akey) => {

            if (adata['value'] !== undefined && adata['value'] !== null && adata['value'] !== '') {
                if (adata['name'] === 'room_charges') {


                    console.log(type_of_management, type_of_package, length_of_stay, total_cost, room_opted);

                    if (length_of_stay !== null && length_of_stay !== '' && length_of_stay) {
                        if (type_of_management === 1) {
                            total_cost = total_cost + (parseFloat(room_opted) * parseInt(length_of_stay));
                            addonSchema[akey]['value'] = parseFloat(room_opted) * parseInt(length_of_stay);
                        }

                        if (type_of_management === 2 && type_of_package === 2) {
                            total_cost = total_cost + (parseFloat(room_opted) * parseInt(length_of_stay));
                            addonSchema[akey]['value'] = parseFloat(room_opted) * parseInt(length_of_stay);
                        }
                        if (type_of_management === 2 && type_of_management === 1) {
                            addonSchema[akey]['value'] = null;
                            addonSchema[akey]['disable'] = true;
                        }

                        // addonSchema[akey]['value'] = parseFloat(room_opted) * parseInt(length_of_stay);
                    } else {
                        total_cost = total_cost + parseFloat(room_opted);
                        addonSchema[akey]['value'] = parseFloat(room_opted);
                    }

                }
                if (adata['name'] !== 'room_charges') {
                    total_cost = total_cost + parseFloat(adata['value'])
                }

            }
        });

        this.setState((state) => ({ 'formData': formData, 'addonSchema': addonSchema, 'total_cost': total_cost }))
    }

    renderBody() {
        let { formData, token_data, payment_mode } = this.state;
        console.clear();
        console.log(token_data);
        if (formData !== undefined) {
            formData.map((feild, key) => {
                // payload[feild['name']] = feild['value'];
                if (feild['name'] === 'counselling_date') {
                    formData[key]['value'] = moment(new Date()).format('YYYY-MM-DD');
                    formData[key]['text'] = moment(new Date()).format('YYYY-MM-DD');
                    formData[key]['disable'] = true;
                }
                if (feild['name'] === 'umr') {
                    formData[key]['value'] = token_data['umr'];
                    formData[key]['text'] = token_data['umr'];
                    formData[key]['disable'] = true;
                }
                if (feild['name'] === 'umr') {
                    formData[key]['value'] = token_data['umr'];
                    formData[key]['text'] = token_data['umr'];
                    formData[key]['disable'] = true;
                }
                if (feild['name'] === 'tokennumber') {
                    formData[key]['value'] = token_data['current_token_count'];
                    formData[key]['text'] = token_data['current_token_count'];
                    formData[key]['disable'] = true;
                }

                if (feild['name'] === 'patientname') {
                    formData[key]['value'] = token_data['patient_name'];
                    formData[key]['text'] = token_data['patient_name'];
                    formData[key]['disable'] = true;
                }

                if (feild['name'] === 'patietmobile') {
                    formData[key]['value'] = token_data['phone_number'];
                    formData[key]['text'] = token_data['token_display_id'];
                    formData[key]['disable'] = true;
                }
                if (feild['name'] === 'doctorid') {
                    formData[key]['value'] = token_data['doctor_id'];
                    formData[key]['text'] = token_data['doctor_name'];
                    formData[key]['disable'] = false;
                }
                if (feild['name'] === 'doctor_speciality') {
                    formData[key]['value'] = token_data['doctor_speciality'];
                    formData[key]['text'] = token_data['doctor_speciality'];
                    formData[key]['disable'] = true;
                }
                // if (feild['name'] === 'counselling_type') {
                //     formData[key]['value'] = token_data['privilege_id'];
                //     formData[key]['text'] = token_data['privilege_id'];
                //     formData[key]['disable'] = true;
                // }

            })
        }


    }
    cancel() {
        this.setState({priviewmodel:false})
    }

    renderBodydata(tags) {
        let { formData, token_data, addonSchema, corporate_comments } = this.state;
        let { getConusellingDetails } = networkList;
        let payload = {
            "ip_no": token_data['ip_number'],
            "counselling_id": token_data ? token_data['previous_counselling_id'] ? token_data['previous_counselling_id'] : tags : tags
        }

        formData.map((feild, key) => {
            // payload[feild['name']] = feild['value'];
            if (feild['name'] === 'counselling_date') {
                formData[key]['value'] = moment(new Date()).format('YYYY-MM-DD');
                formData[key]['text'] = moment(new Date()).format('YYYY-MM-DD');
                formData[key]['disable'] = true;
            }
            if (feild['name'] === 'umr') {
                formData[key]['value'] = token_data['umr'];
                formData[key]['text'] = token_data['umr'];
                formData[key]['disable'] = true;
            }
            if (feild['name'] === 'umr') {
                formData[key]['value'] = token_data['umr'];
                formData[key]['text'] = token_data['umr'];
                formData[key]['disable'] = true;
            }
            if (feild['name'] === 'tokennumber') {
                formData[key]['value'] = token_data['current_token_count'];
                formData[key]['text'] = token_data['current_token_count'];
                formData[key]['disable'] = true;
            }

            if (feild['name'] === 'patientname') {
                formData[key]['value'] = token_data['patient_name'];
                formData[key]['text'] = token_data['patient_name'];
                formData[key]['disable'] = true;
            }

            if (feild['name'] === 'patietmobile') {
                formData[key]['value'] = token_data['phone_number'];
                formData[key]['text'] = token_data['token_display_id'];
                formData[key]['disable'] = true;
            }
            if (feild['name'] === 'doctorid') {
                formData[key]['value'] = token_data['doctor_id'];
                formData[key]['text'] = token_data['doctor_name'];
                formData[key]['disable'] = false;
            }
            if (feild['name'] === 'doctor_speciality') {
                formData[key]['value'] = token_data['doctor_speciality'];
                formData[key]['text'] = token_data['doctor_speciality'];

                formData[key]['disable'] = true;
            }
            // if (feild['name'] === 'counselling_type') {
            //     formData[key]['value'] = token_data['privilege_id'];
            //     formData[key]['text'] = token_data['privilege_id'];
            //     formData[key]['disable'] = true;
            // }

        })

        postService(getConusellingDetails, 'POST', { 'data': payload }).then(res => {
            console.log(res);
            this.setState((state) => ({ loadding: false }));
            if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                let responseData = res['data'][0];
                Storage.store('counselling_save_data', payload);
                let payment_type = responseData['payment_type'];
                if (payment_type === 1) {
                    this.setState((state) => ({ 'payment_mode': true, 'payment': payment_type }));
                    localStorage.setItem('payment', 'Cash')
                } else if (payment_type === 3) {
                    this.setState((state) => ({ 'payment_mode': true, 'payment': payment_type }));
                    localStorage.setItem('payment', 'Corporate')
                } else {
                    localStorage.setItem('payment', 'Insurance')
                    this.setState((state) => ({ 'payment_mode': false, 'payment': payment_type }));
                }
                let type_of_management = responseData['care_management'];
                let type_of_package = responseData['estimate_type'];
                let room_optd_charges = 0;
                let total_est_chargs = parseFloat(responseData['total_estimate_amount']);
                addonSchema.map((addonFeild, addKey) => {
                    Object.keys(responseData).map((feildKey) => {
                        if (addonFeild['name'] === feildKey) {
                            if (addonFeild['name'] === 'room_charges') {
                                if(type_of_package===1){
                                    addonSchema[addKey]['value'] = 0;
                                    addonSchema[addKey]['text'] ='0.00';
                                    addonSchema[addKey]['disable'] = true;
                                }
                                else{
                                    addonSchema[addKey]['value'] = responseData[feildKey];
                                    addonSchema[addKey]['text'] = responseData[feildKey]; 
                                    total_est_chargs = total_est_chargs - parseFloat(responseData[feildKey]);
                                    addonSchema[addKey]['disable'] = false;
                                }
                            }
                            else{
                                addonSchema[addKey]['value'] = responseData[feildKey];
                                addonSchema[addKey]['text'] = responseData[feildKey];
                                total_est_chargs = total_est_chargs - parseFloat(responseData[feildKey]);
                                addonSchema[addKey]['disable'] = false;
                            }
                            
                        }




                        if (addonFeild['name'] === 'Professional_charges') {
                            addonSchema[addKey]['value'] = responseData['professional_charges'];
                            addonSchema[addKey]['text'] = responseData['professional_charges'];
                            total_est_chargs = total_est_chargs - parseFloat(responseData['professional_charges']);
                            addonSchema[addKey]['disable'] = false;
                        }

                        if (addonFeild['name'] === 'Physiotherapy_charges') {
                            addonSchema[addKey]['value'] = responseData['physiotherapy_charges'];
                            addonSchema[addKey]['text'] = responseData['physiotherapy_charges'];
                            total_est_chargs = total_est_chargs - parseFloat(responseData['physiotherapy_charges']);
                            addonSchema[addKey]['disable'] = false;
                        }
                        if (addonFeild['name'] === 'room_charges') {

                            addonSchema[addKey]['disable'] = true;
                        }



                    })
                })

                formData.map((feild, key) => {

                    // if (feild['name'] === 'counselling_type') {
                    //     formData[key]['value'] = responseData['counselling_type'];
                    //     formData[key]['text'] = responseData['counselling_type_value'];
                    //     formData[key]['disable'] = false;
                    // }

                    if (feild['name'] === 'doctorid') {
                        formData[key]['value'] = responseData['doctor_id'];
                        formData[key]['text'] = responseData['doctor_name'];
                        formData[key]['disable'] = false;
                    }
                    if (feild['name'] === 'doctor_speciality') {
                        formData[key]['value'] = responseData['doctor_speciality'];
                        formData[key]['text'] = responseData['doctor_speciality'];
                        formData[key]['disable'] = true;
                    }
                    if (feild['name'] === 'diagnosis') {
                        formData[key]['value'] = responseData['diagnosis'];
                        formData[key]['text'] = responseData['diagnosis'];
                        formData[key]['disable'] = false;
                    }

                    if (feild['name'] === 'estimated_date_of_admission') {
                        console.log('response', responseData['estimated_date_of_admission'])
                        formData[key]['value'] = responseData['estimated_date_of_admission'];
                        formData[key]['text'] = responseData['estimated_date_of_admission'];
                        formData[key]['disable'] = false;
                    }

                    if (feild['name'] === 'payment') {

                        formData[key]['value'] = responseData['payment_type'];
                        formData[key]['text'] = responseData['payment_type_value'];
                        formData[key]['disable'] = false;
                    }

                    if (feild['name'] === 'type_of_management') {
                        formData[key]['value'] = responseData['care_management'];
                        formData[key]['text'] = responseData['care_management_value'];
                        if (payment_type === 1) {
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }
                        if (payment_type === 2) {
                            formData[key]['visible'] = false;
                        }

                    }
                    if (feild['name'] === 'type_of_package') {
                        localStorage.setItem('type_of_package', responseData['estimate_type']);
                        formData[key]['value'] = responseData['estimate_type'];
                        formData[key]['text'] = responseData['estimate_type_value'];
                        if (payment_type === 1) {
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }
                        if (type_of_management === 1) {
                            formData[key]['disable'] = true;
                            formData[key]['visible'] = false;
                        }
                        if (payment_type === 2) {
                            formData[key]['visible'] = false;
                        }
                    }

                    if (feild['name'] === 'type_of_package') {
                        formData[key]['value'] = responseData['estimate_type'];
                        formData[key]['text'] = responseData['estimate_type_value'];
                        if (payment_type === 1) {
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }
                        if (type_of_management === 1) {
                            formData[key]['disable'] = true;
                            formData[key]['visible'] = false;
                        }
                        if (payment_type === 2) {
                            formData[key]['visible'] = false;
                        }
                    }


                    if (feild['name'] === 'package_name') {
                        formData[key]['value'] = responseData['package_name'];
                        formData[key]['text'] = responseData['package_name_value'];
                        localStorage.setItem('package_name', responseData['package_name'])
                        if (payment_type === 1) {
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }
                        if (type_of_management === 1) {
                            formData[key]['disable'] = true;
                            formData[key]['visible'] = false;
                        }
                        if (type_of_package === 1) {
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }
                        else{
                            formData[key]['visible'] = false;
                            formData[key]['disable'] = false;
                        }
                        if (payment_type === 2) {
                            formData[key]['visible'] = false;
                            formData[key]['disable'] = false;
                        }
                    }


                    if (feild['name'] === 'length_of_stay') {
                        formData[key]['value'] = responseData['lenght_of_stay'];
                        formData[key]['text'] = responseData['lenght_of_stay'];
                        if (payment_type === 1) {
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }

                        if (type_of_package === 1) {
                            formData[key]['disable'] = true;
                            formData[key]['visible'] = true;
                        }

                        if (payment_type === 2) {
                            formData[key]['visible'] = false;
                        }

                    }

                    if (feild['name'] === 'surgery_procedure_name') {
                        formData[key]['value'] = responseData['surgery_procedure_name'];
                        formData[key]['text'] = responseData['surgery_procedure_name_value'];
                        if (type_of_management === 1) {
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = false;
                        }

                        if (type_of_management === 2) {
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }


                        // if (payment_type === 2) {
                        //     formData[key]['visible'] = false;
                        // }

                    }
                    if (feild['name'] === 'date_of_surgery') {
                        formData[key]['value'] = responseData['date_of_surgery'];
                        formData[key]['text'] = responseData['date_of_surgery'];
                        if (type_of_management === 1) {
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = false;
                        }
                        if (type_of_management === 2) {
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }
                    }


                    if (feild['name'] === 'room_opted') {
                        formData[key]['value'] = responseData['room_opted'];
                        formData[key]['text'] = responseData['room_opted_name'];
                        // formData[key]['amount'] = total_est_chargs;

                        console.log(responseData['lenght_of_stay'], responseData['room_charges'], type_of_management, type_of_package)
                        if (responseData['lenght_of_stay'] && responseData['lenght_of_stay'] !== 0) {
                            if (type_of_management === 1) {
                                formData[key]['amount'] = (responseData['room_charges'] ? parseFloat(responseData['room_charges']) : 0) / (responseData['lenght_of_stay'] ? parseInt(responseData['lenght_of_stay']) : 0);
                            }
                            if (type_of_management == 2 && type_of_package === 2) {
                                formData[key]['amount'] = (responseData['room_charges'] ? parseFloat(responseData['room_charges']) : 0) / (responseData['lenght_of_stay'] ? parseInt(responseData['lenght_of_stay']) : 0);
                            }
                            if (type_of_management == 2 && type_of_package === 1) {
                                formData[key]['amount'] = responseData['room_charges'] ? parseFloat(responseData['room_charges']) : 0 ;

                                // formData[key]['amount'] = responseData['room_charges'] ? parseFloat(responseData['room_charges']) : 0 / responseData['lenght_of_stay'] ? parseInt(responseData['lenght_of_stay']) : 0;
                            }

                        } else {
                            formData[key]['amount'] = responseData['room_charges'];

                        }


                        if (payment_type === 1) {
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }
                        if (payment_type === 2) {
                            formData[key]['visible'] = false;
                        }
                    }

                    if (feild['name'] === 'room_upgrade_reason') {
                        formData[key]['value'] = responseData['room_upgrade_reason'];
                        formData[key]['text'] = responseData['room_upgrade_reason_value'];
                        if (payment_type === 1) {
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }
                        if (payment_type === 2) {
                            formData[key]['visible'] = false;
                        }
                    }

                    if (feild['name'] === 'room_upgrade') {
                        formData[key]['value'] = responseData['room_upgrade'];
                        formData[key]['text'] = responseData['room_upgrade_name'];
                        if (payment_type === 1) {
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }
                        if (payment_type === 2) {
                            formData[key]['visible'] = false;
                        }
                    }

                })

                this.setState((state) => ({ 'total_cost': responseData['total_estimate_amount'] ? parseFloat(responseData['total_estimate_amount']) : 0, 'corporate_comments': responseData['corporate_comments'] ? responseData['corporate_comments'] : null, 'formData': formData, 'addonSchema': addonSchema }), () => {
                    // this.caluculateTotal();
                });

            }
            // if (res.status) {
            //     formData.map((feild, key) => {
            //         // payload[feild['name']] = feild['value'];
            //         if (feild['name'] === 'counselling_date') {
            //             formData[key]['value'] = new Date();
            //             formData[key]['text'] = new Date();
            //             formData[key]['disable'] = true;
            //         }
            //         if (feild['name'] === 'umr') {
            //             formData[key]['value'] = token_data['umr'];
            //             formData[key]['text'] = token_data['umr'];
            //             formData[key]['disable'] = true;
            //         }
            //         if (feild['name'] === 'umr') {
            //             formData[key]['value'] = token_data['umr'];
            //             formData[key]['text'] = token_data['umr'];
            //             formData[key]['disable'] = true;
            //         }
            //         if (feild['name'] === 'tokennumber') {
            //             formData[key]['value'] = token_data['token_display_id'];
            //             formData[key]['text'] = token_data['token_display_id'];
            //             formData[key]['disable'] = true;
            //         }

            //         if (feild['name'] === 'patientname') {
            //             formData[key]['value'] = token_data['patient_name'];
            //             formData[key]['text'] = token_data['patient_name'];
            //             formData[key]['disable'] = true;
            //         }

            //         if (feild['name'] === 'patietmobile') {
            //             formData[key]['value'] = token_data['phone_number'];
            //             formData[key]['text'] = token_data['token_display_id'];
            //             formData[key]['disable'] = true;
            //         }
            //         if (feild['name'] === 'doctorid') {
            //             formData[key]['value'] = token_data['doctor_id'];
            //             formData[key]['text'] = token_data['doctor_id'];
            //             formData[key]['disable'] = false;
            //         }
            //         if (feild['name'] === 'doctor_speciality') {
            //             formData[key]['disable'] = true;
            //         }
            //         // if (feild['name'] === 'counselling_type') {
            //         //     formData[key]['value'] = token_data['privilege_id'];
            //         //     formData[key]['text'] = token_data['privilege_id'];
            //         //     formData[key]['disable'] = true;
            //         // }

            //     })
            // } else {
            //     Modal.error({
            //         title: 'Error Message',
            //         content: 'Some Thing went wrong,Please try again. later',

            //     })
            // }
        }).catch((error) => {
            this.setState((state) => ({ loadding: false }));
            console.log(error);
            Modal.error({
                title: 'Error Message',
                content: 'Some Thing went wrong,Please try again. later',

            })
        });
    }

    render() {
        let { formData, payment_mode, addonSchema, total_cost, payment, corporate_comments, MandatoryDoc, priviewmodel } = this.state;
        console.log('MandatoryDoc', MandatoryDoc)
        // this.MandatoryDoc()
        return (
            <div>
           
            <div className="row m-5">
                <div className="col-10 p-0">
                <div className="card p-4">
                    <h1 className="text-center text-capitalize text-heading pb-4 mb-0">Financial Counselling</h1>
                    <div className="row">

                        {(formData !== undefined) && <React.Fragment>
                            {formData
                                .map((feild, key) => {

                                    if (feild.element === 'input' && feild.visible) {
                                        return (

                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col'} my-2 ${feild.name}`}
                                                key={key}>
                                                <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                <Inputlayer
                                                    {...this.props}
                                                    {...this.state}
                                                    feildData={feild}
                                                    onInputChanges={this
                                                        .handleChange
                                                        .bind(this)}
                                                />
                                                {(feild.name === 'ipnumber') && <Button type="primary" icon="search"></Button>}
                                            </div>

                                        )
                                    }
                                    if (feild.element === 'select2' && feild.visible) {
                                        return (
                                            <React.Fragment key={key}>
                                                {(feild.name === 'patient_list' && feild.disable === false) &&
                                                    <div className="col-6">
                                                        <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                    </div>}
                                                <div
                                                    className={`${feild.className
                                                        ? feild.className
                                                        : 'col '} my-2 ${feild.name}`}
                                                    key={key}>
                                                    <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                    <Select2
                                                        Queuedata={formData}
                                                        selectdata={feild}
                                                        {...this.props}
                                                        {...this.state}
                                                        onselectChanges={this
                                                            .handleChange
                                                            .bind(this)}
                                                    /> {feild
                                                        .errors
                                                        .map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                            );
                                                        })}
                                                </div>
                                            </React.Fragment>
                                        )
                                    }
                                    if (feild.element === 'date' && feild.visible) {
                                        return (
                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col '} my-2 ${feild.name}`}
                                                key={key}>
                                                <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                <Datepicker
                                                    // Queuedata={filtereData}
                                                    selectdata={feild}
                                                    {...this.props}
                                                    {...this.state}
                                                    onselectChanges={this
                                                        .handleChange
                                                        .bind(this)}
                                                // onselectChanges={this
                                                //     .onChange
                                                //     .bind(this)} 
                                                />{feild
                                                    .errors
                                                    .map((error, eKey) => {
                                                        return (
                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                        );
                                                    })}
                                            </div>
                                        )

                                    }
                                })}

                        </React.Fragment>}
                        {(payment !== null && payment === 3) &&
                            <div className="col-12 my-2">
                                <div className="row">
                                    <div className="col-12">
                                        <p className="data-label w-100 mb-1 pt-2">Comments</p>
                                        <textarea placeholder="comment" value={corporate_comments} className="textarea" onChange={this.commentsChange.bind(this)}>{corporate_comments}</textarea>
                                    </div>
                                </div>
                            </div>}
                        {/*<div className="col-3 pt-3">
                            <input type="checkbox" id="Initial_Counselling" name="Initial_Counselling" value="Initial Counselling" /> <label for="Medical Management" className="data-label w-75">  Initial Counselling</label>
                        </div>
                        <div className="col-3 pt-3">
                            <input type="checkbox" id="Re_counselling" name="Re_counselling" value="Re counsellingt" /> <label for="Surgical Management" className="data-label w-75">  Re counselling</label>
                        </div>*/}
                    </div>                        
                </div>
                <div className="card pt-5 pb-5 my-5">
                    {(payment !== null && payment === 1) && <React.Fragment>
                        <div className="clearfix p-3">
                            <h1 className="text-capitalize text-heading pb-4 float-left">Total Estimated Amount</h1>
                            <h1 className="text-capitalize text-heading pb-4 float-right">Rs. {total_cost}</h1>
                        </div>
                        <div className="financial-table table-responsive">
                            <table className="table table-hover table-bordered">
                                <thead>
                                    <tr>
                                        <td>S.no</td>
                                        <td>Service Groups</td>
                                        <td className="w-50">Specification</td>
                                        <td>Approx Amount</td>
                                    </tr>
                                </thead>

                                <tbody>
                                    {(addonSchema !== undefined) && <React.Fragment>
                                        {addonSchema.map((feild, key) => {
                                            return (<tr key={key}>
                                                <td>{key + 1}</td>
                                                <td>{feild.service_group}</td>
                                                <td>
                                                    <ul>
                                                        {feild['Specification'].map((spec, spek) => {
                                                            return (<li key={spek}>{spec}</li>)
                                                        })}
                                                    </ul>
                                                </td>
                                                <td style={{ verticalAlign: 'middle' }}>
                                                    {(feild.element === 'input' && feild.visible) &&
                                                        <div className="row m-0">
                                                            <div
                                                                className="col-12 p-0"
                                                                key={key}>
                                                                <Inputlayer
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    feildData={feild}
                                                                    onInputChanges={this
                                                                        .handleChange
                                                                        .bind(this)}
                                                                />
                                                                {(feild.name === 'ipnumber') && <Button type="primary" icon="search"></Button>}
                                                            </div>
                                                        </div>


                                                    }
                                                </td>

                                            </tr>)
                                        })}
                                    </React.Fragment>}

                                </tbody>
                            </table>
                        </div>

                        {/* <div className="insurance p-5">
                            <h5 className="data-label w-100">Insurance:</h5>

                            <ul className="pl-3">
                                <li>Insurance Processing Charges (one time charge) will be billed in addition to the above charges for every patient admission.</li>
                                <li>In case a higher category room (beyond eligibility) is opted for, pro rata charges will be levied to you for all services availed. </li>
                                <li>List of Non-Medical Expenses & Insurance Checklist have been provided to you.</li>
                            </ul>
                            <p className="one">Please note that all the above costs are quoted for the stipulated / tentative length of stay. Increase in length of stay or increase in OT
                            time due to clinical complications/comorbidities will elicit additional charges, depending on the complexity of condition / extension of
treatment / period</p>
                            <p className="two mb-2">For cash paying patients, an advance of 80% of the total estimated amount shall be paid at the time of admission by Cash/Card.</p>
                            <p className="two mb-2">All cash paying patients shall maintain a positive cash balance at any time during their stay for medical treatment in the hospital.</p>
                            <p className="two mb-2">Excess Amount paid (upto Rs 10,000) will be refunded to you in cash immediately at the time of final bill clearance.</p>
                            <p className="two mb-2">As per IT Section 269 ST, amount upto Rs 1,99,999 only will be accepted in Cash. Payment above Rs 2,00,000 can be paid
through NEFT/DD/Card</p>
                        </div> */}
                    </React.Fragment>}
                    <div className="row justify-content-center">
                        {(payment !== null && (payment === 1 || payment === 3)) && <React.Fragment>
                            <button className="btn btn-success text-capitalize mr-3" onClick={this.previewdata.bind(this)}>Preview</button>
                        </React.Fragment>}
                        {(payment !== null && payment === 2) && <React.Fragment>
                            <button className="btn btn-success text-capitalize mr-3" onClick={this.showInsuranceForm}>next</button>
                        </React.Fragment>}
                        <button className="btn btn-success btn-next text-capitalize" onClick={this.cancelButton.bind(this)}>cancel</button>


                    </div>


                    {/* {(!payment_mode) &&
                        <div className="row justify-content-center">
                            <button className="btn btn-success btn-next text-capitalize" onClick={this.cancelButton.bind(this)}>cancel</button>
                        </div>} */}
                </div>
                </div>
                <div className="col-2 pl-1 pr-0 mb-5">
                <div className="card p-3 right-panel-sticky">
                    <h4 className="text-center pb-3">Other Info</h4>
                   <Ins_upload {...this.props} {...this.state} />
                   <Finanical_clearance {...this.props} {...this.state} />
                    </div>
                   </div>
                   
                {(this.state.loadding) &&
                    <div className="loadding"> <Spin tip="Loading..." size={'large'}></Spin></div>}
            </div>
            {priviewmodel &&  <Modal
                    title=''
                    centere
                    footer={null}
                    width='100%'
                    zIndex='1021'
                    closable={false}
                    maskClosable={false}
                    visible={priviewmodel}>
                    <div>
                    <PreView_Model {...this.props} {...this.state} />
                    <div className="row justify-content-center pt-4">
                            <button className="btn btn-success d-print-none text-capitalize" onClick={this.submitFinanceForm.bind(this)}>Submit</button>
                            <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={this.cancel.bind(this)}>cancel</button>
                        </div>
                    </div>
                    </Modal>}
            </div>



        )

    }
    
}
export default Finanical_Counselling;